import React from "react";

function NewsAndUpdateReadMore(props) {
  return <div></div>;
}

export default NewsAndUpdateReadMore;
